(function () {
  'use strict';
  function init() {
    function compactChat() {
      var host = document.querySelector('shopify-chat');
      var root = host && host.shadowRoot;
      if (!root || root.getElementById('pd5-chat-style')) return !!root;
      var style = document.createElement('style');
      style.id = 'pd5-chat-style';
      style.textContent = '@media(max-width:767px){.activator{width:48px!important;height:48px!important;min-width:48px!important;padding:12px!important;justify-content:center!important;border-radius:50%!important}.activator__label{display:none!important}.activator__icon{margin:0!important}.activator-nudge{right:12px!important;transform:translateY(var(--pd5-chat-offset,0px))!important}}';
      root.appendChild(style);
      return true;
    }
    if (!compactChat()) {
      var attempts = 0;
      var chatTimer = window.setInterval(function () {
        attempts += 1;
        if (compactChat() || attempts >= 30) window.clearInterval(chatTimer);
      }, 1000);
    }
    if (window.jQuery) {
      window.jQuery(document).on('ajaxSuccess.pd5CartCount', function (event, request, settings, cart) {
        var requestUrl;
        try { requestUrl = new URL(settings.url, window.location.href); } catch (error) { return; }
        if (requestUrl.origin !== window.location.origin || !/\/cart\.js$/.test(requestUrl.pathname) || !cart || typeof cart.item_count !== 'number') return;
        window.jQuery('.pd-mh__count').text(cart.item_count);
        window.jQuery('.pd-mh__cart').attr('aria-label', 'Basket, ' + cart.item_count + ' items');
      });
    }
    var top = document.getElementById('back-top');
    if (top) {
      function visibility() { top.hidden = window.scrollY < 700; }
      visibility();
      window.addEventListener('scroll', visibility, { passive: true });
      top.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
